import { render, staticRenderFns } from "./FoodCategoriesView.vue?vue&type=template&id=1527c124&"
import script from "./FoodCategoriesView.vue?vue&type=script&lang=ts&"
export * from "./FoodCategoriesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports